import React from 'react';
import { gettext } from '@eventbrite/i18n';
import { IconButton } from '@eventbrite/eds-icon-button';

import { CopyChunky } from '@eventbrite/eds-iconography';

export const renderIconButton = () => (
    <IconButton iconType={<CopyChunky />} title={gettext('Copy')} />
);
